module.exports = __webpack_public_path__ + "static/media/Referral_h.46683b25.png";